import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/wms",
      component: () => import("./components/wms/WmsIndex.vue"),
      meta: {
        app: "wms",
      },
      children: [
        {
          path: "",
          component: () => import("./components/wms/WmsHome.vue"),
          name: "wms-home",
          meta: {
            title: "WMS",
          },
        },
        {
          path: "restock",
          component: () => import("./components/wms/WmsRestock.vue"),
          props: {
            restockCurrentVan: true,
          },
          name: "wms-restock-current-van",
          meta: {
            title: "Restocking your van",
          },
        },
        {
          path: "transfer",
          component: () => import("./components/wms/WmsRestock.vue"),
          props: {
            restockCurrentVan: false,
          },
          name: "wms-transfer",
          meta: {
            title: "Transfer products",
          },
        },
        {
          path: "request-restock",
          component: () => import("./components/wms/WmsRestockRequest.vue"),
          name: "wms-request-restock",
          meta: {
            title: "Request a restock",
          },
        },
        {
          path: "search",
          component: () => import("./components/wms/WmsSearch.vue"),
          name: "wms-search",
          meta: {
            title: "Search stock levels",
          },
        },
        {
          path: "stock-count",
          component: () => import("./components/wms/StockCount.vue"),
          name: "wms-stock-count",
          meta: {
            title: "Stock count",
          },
        },
        {
          path: "stock-count/:sessionId/:warehouseId",
          component: () => import("./components/wms/StockCountSession.vue"),
          name: "wms-stock-count-session",
          props: (route) => ({
            sessionId: Number(route.params.sessionId),
            warehouseId: Number(route.params.warehouseId),
          }),
          meta: {
            title: "Counting stock",
          },
        },
        {
          path: "inbound",
          component: () => import("./components/wms/Inbound.vue"),
          name: "wms-inbound",
          meta: {
            title: "Inbound",
          },
        },
        {
          path: "inbound/:warehouseId",
          component: () => import("./components/wms/InboundSession.vue"),
          name: "wms-inbound-session",
          props: (route) => ({
            warehouseId: Number(route.params.warehouseId),
          }),
          meta: {
            title: "Inbound session",
          },
        },
      ],
    },
    {
      path: "/",
      component: () => import("./components/VanToolHome.vue"),
      name: "board",
      meta: {
        app: "vantool",
        title: "Vantool Board",
      },
      children: [
        {
          path: "/workorder/:workOrderId",
          component: () => import("./components/VanToolHome.vue"),
        },
      ],
    },
    {
      path: "/logged-out",
      component: () => import("./components/LoggedOut.vue"),
      name: "logged-out",
      meta: {
        app: "vantool",
        title: "Vantool",
      },
    },
  ],
});

export default router;
